import React, { useEffect, useRef, useState } from "react";

import "./midea_viewer.css";
import { IP } from "./../internalServer"


const MideaViewer = ({ closeMideaviewer, attachment }) => {


  const getFileUrl = (a) => {
    let p = a.replace(/^\./, "");
    return IP + p;
  };

  const getAttachmentString = (file) => {
    if (!file) return "";

    if (typeof file === "string") return file;

    if (file.name) return file.name;
    if (file.file_path) return file.file_path;
    if (file.fileName) return file.fileName;
    if (file.filename) return file.filename;
    if (file.url) return file.url;

    return "";
  };
  const attachmentStr = getAttachmentString(attachment);

  const isPDF = attachmentStr.toLowerCase().endsWith(".pdf");
  const fileUrl = getFileUrl(attachmentStr)

  // 🔽 Auto-download if NOT PDF
  useEffect(() => {
    if (!isPDF && attachment) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = attachment?.split("/")?.pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Close viewer after download
      closeMideaviewer(false);
    }
  }, [isPDF, attachment, fileUrl, closeMideaviewer]);

  return (
    <div className="midea_transprant_body" style={{ marginLeft: "0px" }}>
      <div className="midea_container shadow">
        <img
          alt="close"
          src="/images/cross-circle3.svg"
          className="midea_close_btn"
          onClick={() => closeMideaviewer(false)}
        />

        {/* ✅ Show iframe only for PDF */}
        {isPDF && (
          <iframe
            title="myFrame"
            src={`https://docs.google.com/gview?url=${encodeURIComponent(
              fileUrl
            )}&embedded=true`}
            className="iframe"
          />
        )}
      </div>
    </div>
  );
};

export default MideaViewer;
